import { useLanguage } from "@hilma/netina2all";
import clsx from 'clsx';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useI18n } from "../hooks";

interface PendingMessageProps {
	entityName: string;
}

const PendingMessage: React.FC<PendingMessageProps> = ({ entityName }) => {

	const pending = useI18n(i18n => i18n.am.pending);
	const language = useLanguage();
	const isMobile = useMediaQuery('(max-width: 800px)');


	return <div className='pending-overlay'>
		<div className='pending-text'>
			{!isMobile && <div className={clsx('profile-title', 'title')}>
				{language === 'he' ? `${pending.titleThe}${entityName}` : `${entityName}, ${pending.titleThe}`}
			</div>}
			<div className='bolded'>
				{`${pending.the}${language === 'he' ? entityName : ""} ${pending.sent}`}
			</div>
			{pending.notify}
		</div>
	</div>
}

export default PendingMessage